import { useTranslation } from 'react-i18next'

import { Button } from 'primereact/button'
import { Message } from 'primereact/message'

import { DeliveryForecastDespatchAdvicePackagingMaterial } from '../../../../../../../../data/models'
import { HandleableError } from '../../../../../../../../utils/errors/isXiaError'
import { LoadingScreen } from './common/LoadingScreen'

type SummaryPanelProps = {
  onExit: () => void
  isLoading: boolean
  error?: HandleableError
  data?: DeliveryForecastDespatchAdvicePackagingMaterial[]
}

export const SummaryPanel: React.FC<SummaryPanelProps> = ({
  onExit,
  isLoading = false,
  error,
  data,
}) => {
  const { t } = useTranslation()

  const Footer = () => {
    return (
      <>
        <div className="flex pt-4 justify-content-end">
          <Button
            label={t(
              'masterDataManagement.packagingData.table.upload.dialog.summaryPanel.footer.next',
            )}
            onClick={() => onExit()}
            disabled={isLoading}
          />
        </div>
      </>
    )
  }

  if (isLoading)
    return (
      <>
        <LoadingScreen />
        <Footer />
      </>
    )

  if (error)
    return (
      <>
        <Message
          severity="error"
          className="w-full justify-content-start"
          text={error.message}
        />
        <Footer />
      </>
    )

  return (
    <>
      <div className="flex h-24rem flex-column align-items-center align-content-center justify-content-center">
        <span
          className="pi pi-check-circle p-text-success"
          style={{ color: 'var(--green-500)', fontSize: '4rem' }}
        ></span>
        <h3 className="mt-4">
          {t(
            'masterDataManagement.packagingData.table.upload.dialog.summaryPanel.success',
          )}
        </h3>
        <div className="mt-1">
          {t(
            'masterDataManagement.packagingData.table.upload.dialog.summaryPanel.process',
            {
              processed: data?.length,
              total: data?.length,
            },
          )}
        </div>
      </div>
      <Footer />
    </>
  )
}
